import { Suspense, useState } from "react";
import { EventClaim, VehicleClaimProcessStage } from "../../../types/eventClaim.types";
import { Modal } from "flowbite-react";
import ComboBoxFormik from "../../../common/components/form/ComboBoxFormik";
import { Formik, Form } from 'formik'; // Importe estes componentes
import * as Yup from 'yup'; // Opcional para validação
import ButtonWithLoader from "../../../common/components/ui/loading/ButtonLoading";
import { updateEventClaim } from "../../../common/services/eventCliam.api";
import { useToastContext } from "../../../common/components/ui/toast/toast.context";
import Loading from "@/common/components/ui/loading/Loading";

export type Props = {
  eventClaim?: EventClaim;
  onClose: () => void;
  onSave: (insuranceClaim: EventClaim) => void;
};

const InsuranceClaimSchema = Yup.object().shape({
  eventType: Yup.string().required('Tipo do evento é obrigatório'),
});

export function ChangeClaimStatus(props: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab] = useState('resumo');
  const { notifyError } = useToastContext();
  const initialValues = props.eventClaim || {
    _id: undefined,
    eventType: '',
    eventDate: '',
    location: '',
    state: '',
    city: '',
    licensePlate: '',
    associateName: '',
    vehicleType: '',
    phone: '',
    whatsapp: '',
    email: '',
    reportText: '',
    documents: [],
    associatedTrigger: false,
    thirdPartiesInvolved: false,
    thirdPartiesCount: 0,
    thirdParties: [],
    status: VehicleClaimProcessStage.NOTICE,
  };

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {

      const response = await await updateEventClaim(values);

      if (!response.ok)
        return notifyError(response.message || "Erro ao salvar o sinistro. Por favor, tente novamente.");
      props.onSave(response.data);
      props.onClose();
    } catch (error) {
      console.error("Erro ao salvar sinistro:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Suspense fallback={<Loading />} >

      <Modal
        className='relative text-black'
        show={true}
        onClose={() => props.onClose()}
        size="7x"
        theme={{
          content: {
            base: "relative h-full w-full p-4 md:h-auto",
            inner: "relative rounded-lg bg-white shadow dark:bg-gray-700 max-w-[90%] max-h-[80vh] mx-auto overflow-hidden flex flex-col"
          }
        }}
      >
        <Modal.Header className='text-black'>
          <h2 className='text-black'>
            {initialValues._id ?
              `Evento: ${initialValues.associateName ?
                initialValues.associateName.split(' ').map(name =>
                  name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
                ).join(' ') : 'Desconhecido'
              }` : "Novo Evento"}
          </h2>
        </Modal.Header>
        <Modal.Body>
          {/* Envolva todo o conteúdo do formulário com Formik */}
          <Formik
            initialValues={initialValues}
            validationSchema={InsuranceClaimSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="space-y-4 rounded-lg p-3">
                  {/* Tab Content */}
                  {activeTab === 'resumo' && (
                    <div className="w-full md:pr-2 mb-4 md:mb-0">
                      <ComboBoxFormik
                        label="Status:"
                        name="status"
                        options={[
                          { value: "", label: "-" },
                          { value: VehicleClaimProcessStage.NOTICE, label: "Comunicado" },
                          { value: VehicleClaimProcessStage.NOTICE_VALIDATION, label: "Validação Comunicado" },
                          { value: VehicleClaimProcessStage.ADJUSTMENT, label: "Regulagem" },
                          { value: VehicleClaimProcessStage.ADJUSTMENT_SUPERVISION, label: "Regulagem Supervisão" },
                          { value: VehicleClaimProcessStage.INVESTIGATION, label: "Sindicância" },
                          { value: VehicleClaimProcessStage.INVESTIGATION_VALIDATION, label: "Validação da Sindicância" },
                          { value: VehicleClaimProcessStage.PURCHASE, label: "Compras" },
                          { value: VehicleClaimProcessStage.IN_WORKSHOP, label: "Em Oficina" },
                          { value: VehicleClaimProcessStage.QUALITY_INSPECTION, label: "Inspeção de Qualidade" },
                          { value: VehicleClaimProcessStage.SOLIDY_EXPERIENCE_SURVEY, label: "Experiência Solidy - Pesquisa de Satisfação" }
                        ]}
                      />
                    </div>
                  )}
                  {isLoading && <Loading />}


                  <div className="flex justify-end space-x-3 pt-4">
                    <ButtonWithLoader
                      type="submit"
                      isLoading={isSubmitting}
                      disabled={isSubmitting}
                    >
                      Trocar Status
                    </ButtonWithLoader>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </Suspense>
  );

}